import { $ } from '../../js/vendors/jquery';

class BootstrapTable
{
    constructor( element ) 
    {
        this.element = element;

        this.init();
    }

    init() 
    {
        this.element.on( 'page-change.bs.table', this.onPageChange.bind( this ) );
    }

    onPageChange() 
    {
        $( 'html, body' ).animate( {
            scrollTop: this.element.closest('section').offset().top - 200
        }, 10 );
    }
}

const bootstrapTable = {
    init() {
        const bootstrapTableElements = $( '[data-toggle="table"]' );

        if ( null !== bootstrapTableElements && bootstrapTableElements.length > 0 ) {
            bootstrapTableElements.each( ( index, element ) => {
                new BootstrapTable( $( element ) );
            } );
        }
    }
};

export default bootstrapTable;
